import React from 'react'
import { Grid, Button, Typography, CircularProgress } from '@material-ui/core'
import { Field, Form } from 'react-final-form'
import UploadField from '../../../components/UploadField'
import anexosRepository from './anexosRepository'
import { TextField } from 'elentari'

const AnexosForm = ({ match, onGoBack }) => {
  const validate = data => {
    return {
      file: data.file ? undefined : 'Obrigatório'
    }
  }
  const handleSubmit = async data => {
    const dataCopy = {
      fileName: data.file.name,
      descricao: data.descricao
    }

    const response = await anexosRepository.uploadAnexos(
      match.params.id,
      dataCopy,
      data.file
    )
    if (response.ok) {
      onGoBack && onGoBack()
    }
  }

  return (
    <Grid container alignItems="center" spacing={3}>
      <Grid item sm={12} xs={12}>
        <Typography variant="h6" gutterBottom>
          Adicionar Anexo
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Form onSubmit={handleSubmit} validate={validate}>
          {({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item sm={6} xs={12}>
                  <Field
                    name="descricao"
                    label="Descrição"
                    fullWidth
                    component={TextField}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Field component={UploadField} label="Arquivo" name="file" />
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="baseline"
                    spacing={2}
                  >
                    <Grid item>
                      <Button
                        fullWidth
                        onClick={onGoBack}
                        disabled={submitting}
                        variant="outlined"
                      >
                        Voltar
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        fullWidth
                        type="submit"
                        disabled={submitting}
                        variant="contained"
                        color="primary"
                      >
                        {submitting && <CircularProgress size={24} />}
                        Enviar
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          )}
        </Form>
      </Grid>
    </Grid>
  )
}
export default React.memo(AnexosForm)
